module.exports = __webpack_public_path__ + "r-v3/img/ico_attendance_plus.38f84232.svg";